import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import i18n from '../../../i18n/i18n';
import Select from 'react-select';
import { Fab, Button, Tooltip, Icon, IconButton } from '@material-ui/core';
import { wentWrong } from "../../../utils/ToastConfig";
import axios from '../../../utils/AxiosWrapper';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import SearchBar from 'material-ui-search-bar';
import moment from 'moment';
import * as Icons from '@material-ui/icons';
import { filter } from 'lodash';
import PreviewSowingHistory from './PreviewSowingHistory';


const commonHeaderStyle = {
    textAlign: 'center',
    textTransform: 'uppercase',
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: '#04764e',
    color: "#ffff",

};

const searchWrapStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 30px 20px 30px'
};

const searchBarStyle = {
    width: '40%',
    height: '40px',
    border: '1px solid #979797',
    maxWidth: '421px'
};

export default class ArchiveList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            data: [],
            filteredData: [],
            preview: false,
            selectedId: null,
            searchBarValue: '',
            loading: false
        };

    }

    componentDidMount() {



        this.fetchAllFields();




    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.searchBarValue !== this.state.searchBarValue) {
            this.setState({
                filteredData: prevState.data.filter(item => item.naziv.toLowerCase().includes(this.state.searchBarValue.toLowerCase()))
            })

        }
    }

    fetchAllFields = () => {
        this.setState({ loading: true });
        axios.get(`api/field/field_basic_info`)
            .then(res => {
                console.log('res IGOR', res)
                this.setState({
                    data: res.data.data,
                    filteredData: res.data.data,

                    loading: false
                });
            })
            .catch(error => {
                this.setState({ loading: false });
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getData): ', error);
            })
    }


    handleSearchBar = (searchVal) => {
        this.setState({
            searchBarValue: searchVal
        }, () => {
            if (this.reactTable) {
                this.reactTable.fireFetchData();
            }
        });
    }


    render() {
        const columns = [
            { Header: i18n.t('Title'), accessor: 'naziv', headerStyle: commonHeaderStyle },
            { Header: i18n.t('Land area') + ' (ha)', accessor: 'povrsina', headerStyle: commonHeaderStyle },
            {
                Header: i18n.t('Details'), accessor: 'id',
                Cell: cell => {
                    // console.log('cell', cell)
                    return (

                        <Tooltip title={i18n.t("Details")}>
                            <IconButton aria-label="details" onClick={() => this.setState({ selectedId: cell.original.id }, () => {

                                this.setState({ preview: true }, () => {

                                    console.log('selected id', this.state.selectedId)
                                    console.log('this.state.preview', this.state.preview)
                                }
                                )
                            })
                            }>
                                <Icons.Visibility
                                    //  className={classes.actionIcon} 
                                    fontSize="default" />
                            </IconButton>
                        </Tooltip >

                    );
                }, headerStyle: commonHeaderStyle
            },

        ];


        return (

            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <div style={searchWrapStyle}>
                    <SearchBar
                        style={searchBarStyle}
                        placeholder={i18n.t('Search by name')}
                        cancelOnEscape={true}
                        value={this.state.searchBarValue}
                        onChange={(searchValue) => this.handleSearchBar(searchValue)}
                        onCancelSearch={() => this.handleSearchBar('')}
                    />
                </div>

                <div style={{ border: '1px solid #cecece', backgroundColor: '#fff', margin: '30px 30px 30px 30px', borderRadius: '3px', boxSizing: 'border-box', overflow: 'hidden', boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column' }}>
                    <ReactTable ref={r => (this.reactTable = r)}
                        // manual
                        data={this.state.filteredData}
                        paging={true}
                        columns={columns}
                        keyField={'id'}
                        pageRangeDisplayed={false}
                        defaultPageSize={10}
                        // pageSizeOptions={[10, 25, 50, 100]}
                        // pages={this.state.totalPages}
                        showPaginationBottom={true}
                        // onFetchData={(state, instance) => {
                        //     if (this.state.loading === false) { this.getData(url, state, instance); }
                        // }}
                        loading={this.state.loading}
                        className="-striped -highlight"
                        previousText={'<'}
                        nextText={'>'}
                        pageText={''}
                        loadingText={i18n.t('Loading...')}
                        noDataText={i18n.t('No rows found')}
                        ofText={i18n.t('of')}
                        showPageSizeOptions={false}
                        showPagination={true}
                        rowsText={''}
                        // {...checkboxProps}
                        //{...filterOptions}
                        PreviousComponent={(props) => (
                            <button {...props} className='-btn' style={{
                                backgroundColor: '#4FA2CD',
                                color: '#FFFFFF'
                            }}>{props.children}</button>
                        )}
                        NextComponent={(props) => (
                            <button {...props} className='-btn' style={{
                                backgroundColor: '#4FA2CD',
                                color: '#FFFFFF'
                            }}>{props.children}</button>
                        )}
                        getTrProps={() => {
                            return {
                                style: {
                                    textAlign: 'center',
                                    paddingLeft: '10px',
                                    height: '50px',
                                    alignItems: 'center',
                                    overflowY: 'hidden',
                                    overflowX: 'hidden',
                                }
                            };
                        }}

                        // onPageChange={() => {
                        //     this.state.load = true;
                        // }}

                        NoDataComponent={() => (
                            <div style={{
                                textAlign: 'center', padding: '20px', display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: -300
                            }}>
                                {!this.state.load && <span>{i18n.t('No rows found')}</span>}
                            </div>
                        )}
                    />
                </div>
                {this.state.preview &&
                    <PreviewSowingHistory
                        open={this.state.preview}
                        id={this.state.selectedId}
                        handleClose={() => this.setState({ preview: false })}
                    />
                }
            </div>

        );
    }
}

